import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import PaymentCreate from "pages/payments/PaymentCreate";
import PaymentList from "pages/payments/PaymentList";
import React from "react";
import { GiMoneyStack } from "react-icons/gi";
import { MdAddBox } from "react-icons/md";

const PaymentsManagement = () => {
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Payment"
        viewIcon={<GiMoneyStack />}
        createIcon={<MdAddBox />}
        createChildren={<PaymentCreate />}
        listChildren={<PaymentList />}
      />
    </Box>
  );
};

export default PaymentsManagement;
